import { render } from "./template.html?vue&type=template&id=5edcf987&scoped=true&ts=true&external"
import script from "./AppLogo.vue?vue&type=script&lang=ts"
export * from "./AppLogo.vue?vue&type=script&lang=ts"

import "./style.scss?vue&type=style&index=0&id=5edcf987&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5edcf987"]])

export default __exports__